<template>
  <div class="h-full flex flex-col bg-white">
    <div class="panel-header">
      <span>{{ $t('Data') }}</span>
    </div>
    <div class="panel-content space-y-5">
      <div class="text-center">
        <el-button
          type="warning"
          @click="$emit('openPrice')"
          class="px-8 py-3 text-sm font-semibold w-full"
          size="large"
        >
          <span>💎 {{ $t('Price') }}</span>
        </el-button>
      </div>

      <div>
        <div class="panel-section-title">{{ $t('Add Data') }}</div>
        <div class="space-y-3">
          <div>
            <label class="text-xs font-medium text-gray-500">源节点</label>
            <el-input
              v-model="localSource"
              :placeholder="$t('source')"
              clearable
              size="default"
            />
          </div>

          <div>
            <label class="text-xs font-medium text-gray-500">目标节点</label>
            <el-input
              v-model="localTarget"
              :placeholder="$t('target')"
              clearable
              size="default"
            />
          </div>

          <div>
            <label class="text-xs font-medium text-gray-500">数值</label>
            <el-input-number
              v-model="localValue"
              :placeholder="$t('value')"
              class="w-full"
              clearable
              size="default"
              :min="0"
            />
          </div>
        </div>
        <el-button
          type="primary"
          class="w-full mt-3 py-3 text-sm font-semibold"
          @click="handleAddData"
          size="large"
        >
          <span>✨ {{ $t('Add Data') }}</span>
        </el-button>
      </div>

      <!-- 数据表格 -->
      <div>
        <div class="panel-section-title">{{ $t('Dataset') }}</div>
        <el-scrollbar max-height="40vh">
          <el-table :data="chartData" class="w-full" size="small">
            <el-table-column prop="source" :label="$t('Source')" />
            <el-table-column prop="target" :label="$t('Target')" />
            <el-table-column prop="value" :label="$t('Value')" />
            <el-table-column :label="$t('Operations')" width="80" align="center">
              <template #default="scope">
                <el-button
                  circle
                  type="danger"
                  @click="$emit('deleteData', scope.$index)"
                  size="small"
                >
                  <el-icon><Delete /></el-icon>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>

      <!-- 语言选择和底部按钮 -->
      <div class="border-t border-gray-100 pt-4">
        <el-select
          v-model="selectedLang"
          @change="$emit('changeLang', $event)"
          placeholder="Select Language"
          class="w-full"
          size="default"
        >
          <el-option
            v-for="(item, index) in languageOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>

        <div class="flex justify-center mt-3">
          <el-button
            plain
            @click="$emit('openService')"
            class="rounded-full px-6 py-2 text-sm"
            size="default"
          >
            {{ $t('Service') }}
          </el-button>
        </div>

        <p class="text-xs text-gray-400 text-center mt-3">
          Copyright © emperinter
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Delete } from '@element-plus/icons-vue'

const props = defineProps({
  chartData: {
    type: Array,
    default: () => []
  },
  source: {
    type: String,
    default: ''
  },
  target: {
    type: String,
    default: ''
  },
  value: {
    type: Number,
    default: 0
  }
})

const emit = defineEmits(['openPrice', 'addData', 'deleteData', 'changeLang', 'openService'])

const localSource = ref(props.source)
const localTarget = ref(props.target)
const localValue = ref(props.value)
const selectedLang = ref(null)

// 语言选项
const languageOptions = [
  { label: 'English', value: 'en-US' },
  { label: '中文', value: 'cn' },
  { label: '日本語', value: 'ja' },
  { label: 'Français', value: 'fr' },
  { label: 'Deutsch', value: 'de' },
  { label: 'Italiano', value: 'it' },
  { label: 'Español', value: 'es' },
  { label: '한국어', value: 'ko' }
]

const handleAddData = () => {
  if (localSource.value && localTarget.value && localValue.value > 0) {
    emit('addData', {
      source: localSource.value,
      target: localTarget.value,
      value: localValue.value
    })
    localSource.value = ''
    localTarget.value = ''
    localValue.value = 0
  }
}
</script>
